import { defaultDataIdFromObject } from 'apollo-cache-inmemory';
const dataIdFromObject = (object) => {
    const id = defaultDataIdFromObject(object);
    if (object.hasOwnProperty('organisationId') &&
        object.hasOwnProperty('orgStructureLevelId')) {
        return `${id}:${object.organisationId}:${object.orgStructureLevelId}`;
    }
    if (object.hasOwnProperty('organisationId')) {
        return `${id}:${object.organisationId}`;
    }
    if (object.hasOwnProperty('dayType')) {
        return `${id}:${object.dayType}`;
    }
    if (object.hasOwnProperty('type')) {
        return `${id}:${object.type}`;
    }
    if (object.hasOwnProperty('communicationType')) {
        return `${id}:${object.communicationType}`;
    }
    if (object.hasOwnProperty('pltId') && object.hasOwnProperty('sequence')) {
        return `${id}:${object.sequence}`;
    }
    return id;
};
export default dataIdFromObject;
